import { createTheme } from '@mui/material';
import { components } from './overrides.js';
import { injectPalette } from './palette.js';
import { injectTypography } from './typography.js';
import { injectZIndex } from './z-index.js';

const createSitooTheme = function () {
  let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  const theme = createTheme({
    components
  });
  injectPalette(theme, mode);
  injectTypography(theme);
  injectZIndex(theme);
  return theme;
};

export { createSitooTheme };
